module.exports = __webpack_public_path__ + "static/media/acura-logo.e74791c6.png";